"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fieldset = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _responsiveProps = require("../../../internal/responsiveProps");
var _Wrapper = _interopRequireDefault(require("../../Wrapper"));
var _tokens = require("../../../tokens");
var _text = require("../../../helpers/text");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const HORIZONTAL_LAYOUT_ITEM_PADDING = {
  VERTICAL: `${12 / 2}px`,
  HORIZONTAL: `${parseInt(_tokens.GTR.M) / 2}px`
};
const StyledLegend = _styledComponents.default.legend.withConfig({
  displayName: "StyledLegend",
  componentId: "sc-1lm4oq1-0"
})(["", ";padding:0;"], _text.headingXS);
const StyledContent = (0, _styledComponents.default)(_Wrapper.default).withConfig({
  displayName: "StyledContent",
  componentId: "sc-1lm4oq1-1"
})(["> *{margin:", " 0;}"], _tokens.GTR.XS);
const StyledWrapper = (0, _styledComponents.default)(_Wrapper.default).withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-1lm4oq1-2"
})(["margin:", " 0;", ""], _tokens.GTR.M, props => (0, _responsiveProps.responsiveCssProps)({
  props: props,
  propName: 'horizontal',
  output: v => v && `
        ${StyledContent} {
          display: flex;
          flex-wrap: wrap;
          margin: -${HORIZONTAL_LAYOUT_ITEM_PADDING.VERTICAL} -${HORIZONTAL_LAYOUT_ITEM_PADDING.HORIZONTAL};
        }

        ${StyledContent} > * {
          margin: ${HORIZONTAL_LAYOUT_ITEM_PADDING.VERTICAL} ${HORIZONTAL_LAYOUT_ITEM_PADDING.HORIZONTAL};
        }
      `
}));

/**
## Usage

```js
import { Fieldset } from '@farewill/ui'
```

### How to use this component

`<Fieldset>` is a light wrapper for laying out groups of input components. It extends from `<Wrapper>` so can use any of `<Wrapper>`’s styling functionality.

Group checkbox and radio groups together in a `fieldset` with a `legend` that describes them

#### Inline checkboxes and radios

In some cases, you can choose to display groups horizontally.

Only use horizontal layout when the question has two options and both options are short.

#### Internal services

If there are lots of options, consider using a select instead of a checkbox or radio group. Avoid using select for user-facing services.

*/

const Fieldset = _ref => {
  let {
    legend,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, _extends({
    omitProps: {
      responsiveKeys: ['horizontal']
    }
  }, props, {
    tag: "fieldset"
  }), legend && /*#__PURE__*/_react.default.createElement(StyledLegend, null, legend), /*#__PURE__*/_react.default.createElement(StyledContent, null, children));
};
exports.Fieldset = Fieldset;